<template>
  <div class="flex flex-col">
    <div class="px-4 pt-4">
      <div class="flex">
        <div
          class="font-bold text-md flex items-center justify-center leading-normal"
        >
          <span v-text="label"></span>
        </div>

        <div class="flex-grow"></div>

        <div
          v-on:click="peek"
          v-show="hint"
          class="flex items-center justify-center h-icon w-icon"
        >
          <img v-bind:src="getIcon()" />
        </div>
      </div>
    </div>

    <div class="w-full flex items-center justify-center my-5">
      <v-otp-input
        :is-disabled="false"
        ref="pinOTP"
        input-classes="otp-input"
        :input-type="hidden ? 'password' : 'text'"
        inputmode="numeric"
        :num-inputs="length"
        v-model:value="pin"
        :should-auto-focus="true"
        :should-focus-order="true"
        :key="otp_input_key"
        @on-complete="complete"
        @on-change="typing"
      />
    </div>
  </div>
</template>

<script>
import VOtpInput from "vue3-otp-input";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],

  components: {
    VOtpInput,
  },

  props: {
    label: {
      type: String,
    },
    hint: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      length: 6,
      hidden: true,
      pin: "",
      otp_input_key: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const inputs = this.$el.querySelectorAll(".otp-input");

      inputs.forEach((input) => {
        input.addEventListener("keydown", this.onlyNumeric);
        input.addEventListener("input", this.sanitizeNumeric);
      });
    });

    if (this.value != null) {
      this.pin = this.value;
    }
  },

  beforeUnmount() {
    const inputs = this.$el.querySelectorAll(".otp-input");

    inputs.forEach((input) => {
      input.removeEventListener("keydown", this.onlyNumeric);
      input.removeEventListener("input", this.sanitizeNumeric);
    });
  },

  methods: {
    typing(value) {
      const numeric_value = value.replace(/\D/g, "");

      this.pin = numeric_value;
      this.$emit("typing", numeric_value);
    },

    complete(value) {
      const numeric_value = value.replace(/\D/g, "");

      this.pin = numeric_value;
      this.$emit("complete", numeric_value);
    },

    onlyNumeric(event) {
      const allowed_keys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (allowed_keys.includes(event.key)) {
        return;
      }

      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },

    sanitizeNumeric(event) {
      const input = event.target;
      const numeric_value = input.value.replace(/\D/g, "");

      if (input.value !== numeric_value) {
        input.value = numeric_value;
      }
    },

    peek() {
      this.hidden = !this.hidden;
    },

    getIcon() {
      return require(
        !this.hidden
          ? "@/assets/icons/papsi_password_visible.svg"
          : "@/assets/icons/papsi_password_invisible.svg"
      );
    },
  },

  watch: {
    value(value) {
      this.pin = value;
    },
  },
};
</script>

<style scoped>
</style>